export default __webpack_public_path__ + "d6bd015482c945c1831cd4d2c2045900.png";